import Vue from 'vue';
import Router from 'vue-router';
import Login from '../views/Login.vue';
import Customer from '../views/Customer.vue';
import Home from '../views/Home.vue';
import Devices from '../views/Devices.vue';
import Drivers from '../views/Drivers.vue';
import Tours from '../views/Tours.vue';
import Users from '../views/Users.vue';
import Contracts from '../views/Contracts.vue';
import Locations from '../views/Locations.vue';
import Dashboard from '../views/Dashboard.vue';
import Updates from '../views/Updates.vue';

Vue.use(Router);

export const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children: [
        { path: 'customer', name: 'customer', component: Customer },
        { path: 'dashboard', name: 'dashboard', component: Dashboard },
        { path: 'devices', name: 'devices', component: Devices },
        { path: 'drivers', name: 'drivers', component: Drivers },
        { path: 'tours', name: 'tours', component: Tours },
        { path: 'users', name: 'users', component: Users },
        { path: 'contracts', name: 'contracts', component: Contracts },
        { path: 'updates', name: 'updates', component: Updates },
        { path: 'locations', name: 'locations', component: Locations }
      ]
    },
    { path: '/login', name: 'login', component: Login },
    { path: '*', redirect: '/' }
  ]
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  next();
});
